import React, { FC } from "react";
import { useMedia } from "react-use";

import { MEDIA_SIZE_MD, MEDIA_SIZE_SM } from "@/core/media";

import { NavigationDesktop } from "./NavigationDesktop";
import { NavigationMediumScreen } from "./NavigationMediumScreen";
import { NavigationMobile } from "./NavigationMobile";

import "./_navigation.scss";

export interface INavigationProps {}

export const Navigation: FC<INavigationProps> = React.memo(() => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);
  const isMediumScreen = useMedia(MEDIA_SIZE_MD);

  return isSmallScreen ? <NavigationMobile /> : isMediumScreen ? <NavigationMediumScreen /> : <NavigationDesktop />;
});
